function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m56 18h-16.262c-.889 3.449-4.01 6-7.738 6s-6.849-2.551-7.738-6h-16.262c-2.21 0-4 1.79-4 4v32h28 28v-32c0-2.21-1.79-4-4-4z",
  fill: "#ccd1d9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6 62c-2.21 0-4-1.79-4-4v-4h2 28 28 2v4c0 2.21-1.79 4-4 4h-26z",
  fill: "#969faa"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m55 22h-46c-.55 0-1 .45-1 1v26c0 .55.45 1 1 1h23 23c.55 0 1-.45 1-1v-26c0-.55-.45-1-1-1z",
  fill: "#69d6f4"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m27 35.4c.64 1.05 1 2.28 1 3.6 0 3.87-3.13 7-7 7s-7-3.13-7-7 3.13-7 7-7c2.55 0 4.78 1.36 6 3.4z",
  fill: "#b4dd7f"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 43,
  cy: 39,
  fill: "#ff826e",
  r: 7
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m32 8c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm4 8c0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4 4-1.79 4-4z",
  fill: "#fcd770"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m46 18v1l-2.56.63c-.21.66-.48 1.28-.79 1.88l.31.51 1.06 1.76-4.24 4.24-2.27-1.37c-.6.31-1.22.58-1.88.79l-.63 2.56h-6l-.63-2.56c-.66-.21-1.28-.48-1.88-.79l-2.27 1.37-4.24-4.24 1.06-1.76.31-.51c-.31-.6-.58-1.22-.79-1.88l-2.56-.63v-1-5l2.56-.63c.21-.66.48-1.28.79-1.88l-1.37-2.27 4.24-4.24 2.27 1.37c.6-.31 1.22-.58 1.88-.79l.63-2.56h6l.63 2.56c.66.21 1.28.48 1.88.79l2.27-1.37 4.24 4.24-1.37 2.27c.31.6.58 1.22.79 1.88l2.56.63zm-6-2c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8 8-3.58 8-8z",
  fill: "#ffc729"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m32 25c4.962 0 9-4.037 9-9s-4.038-9-9-9-9 4.037-9 9 4.038 9 9 9zm0-16c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m32 21c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m61 53v-31c0-2.757-2.243-5-5-5h-9v-4.784l-2.794-.687c-.123-.332-.262-.664-.416-.994l1.492-2.467-5.351-5.351-2.466 1.493c-.331-.154-.663-.293-.995-.416l-.686-2.794h-7.568l-.687 2.794c-.332.123-.664.262-.995.416l-2.466-1.492-5.352 5.352 1.493 2.466c-.154.33-.293.662-.417.994l-2.792.686v4.784h-9c-2.757 0-5 2.243-5 5v31h-2v5c0 2.757 2.243 5 5 5h52c2.757 0 5-2.243 5-5v-5zm-42-39.216 2.345-.577.17-.534c.182-.572.425-1.153.722-1.728l.258-.498-1.255-2.073 3.134-3.133 2.073 1.255.499-.259c.574-.298 1.154-.541 1.725-.722l.536-.169.577-2.346h4.432l.577 2.347.536.169c.571.181 1.151.424 1.725.722l.499.259 2.073-1.255 3.134 3.134-1.255 2.072.258.498c.297.572.54 1.153.722 1.728l.17.534 2.345.576v4.432l-2.345.577-.17.534c-.182.574-.425 1.155-.722 1.728l-.258.498 1.255 2.072-3.134 3.134-2.073-1.255-.499.259c-.574.298-1.154.541-1.725.722l-.536.169-.577 2.346h-4.432l-.577-2.345-.534-.17c-.573-.182-1.154-.425-1.727-.723l-.499-.259-2.073 1.255-3.134-3.134 1.255-2.072-.258-.498c-.297-.572-.54-1.153-.722-1.728l-.17-.534-2.345-.576zm5.069 15.498 2.466-1.492c.33.154.662.293.995.416l.686 2.794h7.568l.687-2.794c.332-.123.664-.262.995-.416l2.466 1.492 5.351-5.351-.564-.931h10.281v26h-46v-26h10.281l-.564.932zm-19.069-7.282c0-1.654 1.346-3 3-3h9v.784l2.794.687c.065.177.147.353.221.529h-11.015c-1.103 0-2 .897-2 2v26c0 1.103.897 2 2 2h46c1.103 0 2-.897 2-2v-26c0-1.103-.897-2-2-2h-11.015c.074-.177.156-.353.221-.529l2.794-.687v-.784h9c1.654 0 3 1.346 3 3v31h-54zm56 36c0 1.654-1.346 3-3 3h-52c-1.654 0-3-1.346-3-3v-3h58z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m5 57h2v2h-2z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m9 57h2v2h-2z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m13 57h2v2h-2z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m13 39c0 4.411 3.589 8 8 8s8-3.589 8-8c0-1.189-.268-2.315-.736-3.331l2.36-1.888-1.249-1.562-2.173 1.738c-1.467-1.802-3.702-2.957-6.202-2.957-4.411 0-8 3.589-8 8zm8-6c1.87 0 3.542.86 4.643 2.205l-5.569 4.455-2.367-2.367-1.414 1.414 3.633 3.633 6.713-5.37c.229.635.361 1.317.361 2.03 0 3.309-2.691 6-6 6s-6-2.691-6-6 2.691-6 6-6z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m43 47c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40.707 42.707 2.293-2.293 2.293 2.293 1.414-1.414-2.293-2.293 2.293-2.293-1.414-1.414-2.293 2.293-2.293-2.293-1.414 1.414 2.293 2.293-2.293 2.293z"
});

var SvgTesting = function SvgTesting(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_35",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTesting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/testing.aa2d457f.svg";
export { ForwardRef as ReactComponent };